import React from "react";
import { useState } from "react";
import "./section3.css";
import { FaFacebookF, FaInstagram, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import WorldMapComponent from "../WorldMapComponent";

function Section3() {
  const [formData, setFormData] = useState({
    name: { value: "", error: "" },
    email: { value: "", error: "" },
    message: "",
  });
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleSubmit2 = (e) => {
    e.preventDefault();
    
    // Validate newsletter email
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert("Please enter a valid email address");
      return;
    }

    // Submit newsletter email to the same Google Apps Script
    const url = `https://script.google.com/macros/s/AKfycbw6Q3fqpU3bCVtiv_B6xRaHMFFMn1yV-by6e-RBUt0TLOE6pJeMJBzxjDHqK5cdgSP4/exec?name=${encodeURIComponent(
      "Subscriber"
    )}&email=${encodeURIComponent(
      email
    )}&query=${encodeURIComponent("Subscription request")}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log("Subscription successful:", data);
        alert("Thank you for subscribing!");
        setEmail("");
      })
      .catch((error) => {
        console.error("Error subscribing:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    
    // Validation for name
    if (name === "name") {
      error = /^[a-zA-Z\s]+$/.test(value) ? "" : "Enter a valid name";
    }
    // Validation for email
    if (name === "email") {
      error = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ? ""
        : "Enter a valid email";
    }
    
    if (name === "message") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: { ...prevData[name], value, error },
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    
    // Check if there are any validation errors
    if (formData.name.error || formData.email.error) {
      console.error("Form has validation errors");
      setSubmitMessage("Please fix the validation errors");
      return; // Exit function if there are validation errors
    }

    // Check if mandatory fields are filled (only name and email are required)
    if (!formData.name.value || !formData.email.value) {
      setSubmitMessage("Please fill in Name and Email fields");
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage("");

    // If validation passes, construct the URL with form data
    // Use empty string for message if not provided
    const message = formData.message || "No specific message provided";
    const url = `https://script.google.com/macros/s/AKfycbw6Q3fqpU3bCVtiv_B6xRaHMFFMn1yV-by6e-RBUt0TLOE6pJeMJBzxjDHqK5cdgSP4/exec?name=${encodeURIComponent(
      formData.name.value
    )}&email=${encodeURIComponent(
      formData.email.value
    )}&query=${encodeURIComponent(message)}`;

    // Execute the constructed URL
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log("Google Sheet submission successful:", data);
        setSubmitMessage("Thank you! Your message has been sent successfully.");
        // Reset form
        setFormData({
          name: { value: "", error: "" },
          email: { value: "", error: "" },
          message: "",
        });
        // Additional logic after successful Google Sheet submission
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        console.error("Error submitting to Google Sheet:", error);
        setSubmitMessage("Something went wrong. Please try again.");
        // Additional error handling logic
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="Section3">
      <div className="contact" id="contact">
        <div className="contact-1">
          <div className="contact-1-1">
            <h1>
              We're Here To <span className="contact-1-1-heading">Help</span>{" "}
              <br />
              You <span className="contact-1-1-heading">Grow</span>
            </h1>
            <p>
              Whether you're scheduling your first consultation or a follow-up
              strategy session, our appointments are key to building Client
              relationships.
            </p>
          </div>
          <div className="contact-1-2">
            <div className="contact-1-2-1">
              <h2 className="contact-2form-para{">Phone Number</h2>
              <p>+91 87008 50464</p>
            </div>
            <div className="contact-1-2-2">
              <h2 className="contact-2form-para{">Email Address</h2>
              <p>admin@purpleedgecorp.com</p>
            </div>
          </div>
          <div className="contact-1-3">
            <p>Follow us</p>
            <div className="social-container">
          
              <div className="icon-wrapper">
                <a href="https://www.instagram.com/saving_energy.au/">
                  <FaLinkedin className="icon instagram" />
                </a>
              </div>
              {/* <div className="icon-wrapper">
                
                <FaXTwitter className="icon x" />
              </div> */}
            </div>
          </div>
        </div>
        <div className="contact-2">
          <form className="contact-2form" onSubmit={handleSubmit}>
            <h1>We'd love to hear from you! Let's get in touch</h1>

            <p className="contact-2form-para">Full Name *</p>
            <input
              name="name"
              value={formData.name.value}
              onChange={handleChange}
              placeholder="Enter Your Name"
              required
            />
            {formData.name.error && (
              <span className="error-message">{formData.name.error}</span>
            )}

            <p className="contact-2form-para">Email *</p>
            <input
              type="email"
              name="email"
              value={formData.email.value}
              onChange={handleChange}
              placeholder="Enter Your Email"
              required
            />
            {formData.email.error && (
              <span className="error-message">{formData.email.error}</span>
            )}

            <p className="contact-2form-para">How we can help? (Optional)</p>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="How we can help You?"
            />

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Send Message"}
            </button>

            {submitMessage && (
              <div className={`submit-message ${submitMessage.includes('Thank you') ? 'success' : 'error'}`}>
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </div>
      <div className="map">
        <WorldMapComponent />
      </div>
      <footer className="footer">
        <div className="footer-leads">
          <div className="newsletter-container">
            <div className="newsletter-text">
              <h2>
                Get our <span className="italic">Subscription</span> for
              </h2>
              <h2>
                updates <span className="italic">services & offer</span>
              </h2>
            </div>

            <form onSubmit={handleSubmit2} className="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
              />
              <button type="submit">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M13.4 12l-4.7-4.7 1.4-1.4 6.1 6.1-6.1 6.1-1.4-1.4z" />
                </svg>
              </button>
            </form>
          </div>
        </div>

        <div className="footer-info">
          <div className="footer-1">
            <div className="company-logo">
              <img src="logo.jpeg" alt="Company Logo" />
              <h3>Marketing</h3>
            </div>
            <p className="company-description">
            Our agency delivers comprehensive operational solutions designed to streamline your business processes, enhance customer experiences, and support scalable growth through expert backend execution and virtual team coordination.
            </p>
            <div className="social-container">
            
              <div className="icon-wrapper">
                <a href="https://www.instagram.com/saving_energy.au/">
                  <FaLinkedin className="icon instagram" />
                </a>
              </div>
              {/* <div className="icon-wrapper">
                
                <FaXTwitter className="icon x" />
              </div> */}
            </div>
          </div>

          <div className="footer-2">
            <div className="footer-links">
              <h4>Explore</h4>
              <ul>
                <li>
                  <a href="#headerContainer" onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('.headerContainer')?.scrollIntoView({ behavior: 'smooth' });
                  }}>About Us</a>
                </li>
                <li>
                  <a href="#servicesContainer" onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('.servicesContainer')?.scrollIntoView({ behavior: 'smooth' });
                  }}>Our Services</a>
                </li>
          
                <li>
                  <a href="#section2MainContainer" onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('.section2MainContainer')?.scrollIntoView({ behavior: 'smooth' });
                  }}>Our Growth</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-3">
            <div className="footer-links">
              <h4>Support</h4>
              <ul>
                <li>
                  <a href="#contact" onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('.contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}>Contact Us</a>
                </li>
                <li>
                  <a href="#ourApproachContainer" onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('.ourApproachContainer')?.scrollIntoView({ behavior: 'smooth' });
                  }}>Our Working Process</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-4">
            <div className="footer-contact">
              <h4>Get in Touch</h4>
              <p>69/6A, Rama Road, behind The Oreanns Banquet, Industrial Area, New Delhi, Delhi, India</p>
              <p>+91 87008 50464</p>
              <p>
                <a href="mailto:admin@purpleedgecorp.com">admin@purpleedgecorp.com</a>
              </p>
            </div>
          </div>
        </div>

        <div className="footer-end">
          <p>2025 © PurpleEdge Enterprises LLP. All rights reserved</p>
        </div>
      </footer>
    </div>
  );
}

export default Section3;